import {h, Fragment} from "preact"
import { useAppState, InfiniteScroll } from '@nosto/preact'
import { useEffect, useState } from 'preact/hooks'

import NoResults from './NoResults'
import Products from './Products'
import Toolbar from './Toolbar'
import BottomToolbar from './BottomToolbar'
import Loader from './Loader'

export default () => {
    const { response: { products, query }, loading, pageType } = useAppState();
    const foundProducts = products && products.total > 0;
    const isMobile = window.innerWidth < 769;

    useEffect(() => {
        const categoryTagEl = document.querySelector('.nosto_category');
        if(categoryTagEl) { 
            categoryTagEl.remove();
        }
        let pageTagEl = document.querySelector('.nosto_page_type');
        if(pageTagEl && pageTagEl.textContent !== 'search') {
            pageTagEl.textContent = 'search';
        } else if (!pageTagEl) {
            pageTagEl = document.createElement('div');
            pageTagEl.className = 'nosto_page_type';
            pageTagEl.style = 'display: none;';
            pageTagEl.setAttribute('translate', 'no');
            pageTagEl.textContent = 'search';
            document.body.appendChild(pageTagEl);
        };
    }, []);

    useEffect(() => {
        if(!query) return;
        let searchTagEl = document.querySelector('.nosto_search_term');
        if(searchTagEl && searchTagEl.textContent !== query) {
            searchTagEl.textContent = query;
        } else if(!searchTagEl) {
            searchTagEl = document.createElement('div');
            searchTagEl.className = 'nosto_search_term';
            searchTagEl.style = 'display: none;';
            searchTagEl.setAttribute('translate', 'no');
            searchTagEl.textContent = query;
            document.body.appendChild(searchTagEl);
        };
    }, [ query ]);

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth < 769
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
                isMobile: window.innerWidth < 769
            });
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-my-0 ns-mx-auto" data-nosto-element="search">
            <div
                class={`ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0 ${pageType == "search" ? '' : ' ns-pl-md-5 '}`}
                style={loading ? 'position: relative;' : ''}
            >
                {(foundProducts) ? (
                    <>
                        {pageType == "search" && <div class="ns-serp-title" style="padding-bottom: 2rem;">Result{products.total > 1 ? 's' : ''} for '{ query }'</div>}
                        <Toolbar
                            cardWidth={!windowSize?.isMobile ? "calc(((100% - (var(--ns-plp-grid-gutter) * 2)) / 3))" : "calc(((100% - (var(--ns-plp-grid-gutter))) / 2))"}
                        />
                        {pageType == "category" && <div class="text-center" style="padding-bottom: 2rem;">Result{products.total > 1 ? 's' : ''} for '{ query }'</div>}
                        <InfiniteScroll>
                            <Products
                                cardWidth={!windowSize?.isMobile ? "calc(((100% - (var(--ns-plp-grid-gutter) * 2)) / 3))" : "calc(((100% - (var(--ns-plp-grid-gutter))) / 2))"}
                            />
                        </InfiniteScroll>
                        <BottomToolbar />
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )}
            </div>
        </div>
    )
}
